import { useQuery } from "@tanstack/react-query";
import { queries } from "@core-shop/cache";

export function useGiftcardDetails({ id = "" }) {
  return useQuery({ ...queries.giftcardDetails(id), enabled: !!id });
}
